export default __webpack_public_path__ + "static/media/5119764B-AA3F-4D08-B1D5-ABCA849D8B7E_1_105_c.e2fb8cad.jpeg";